<div class="pose-coach-container">
  <!-- En-tête -->
  <div class="header">
    <h1>Coach de Pose AI</h1>
    <div class="status-indicators">
      <span class="status" [class.active]="isWebcamStarted">📹 Webcam</span>
      <span class="status" [class.active]="isSessionActive">🏃 Session</span>
    </div>
  </div>

  <!-- Contrôles -->
  <div class="controls">
    <!-- Sélection caméra -->
    <div class="control-group">
      <label>Caméra:</label>
      <select [(ngModel)]="selectedCameraId" (change)="selectCamera()">
        <option *ngFor="let camera of availableCameras" [value]="camera.deviceId">
          {{camera.label || 'Caméra ' + camera.deviceId.substring(0, 8)}}
        </option>
      </select>
    </div>

    <!-- Niveau utilisateur -->
    <div class="control-group">
      <label>Niveau:</label>
      <div class="level-buttons">
        <button *ngFor="let level of ['novice', 'intermediate', 'expert']"
                [class.active]="userLevel === level"
                (click)="setUserLevel(level)">
          {{level | titlecase}}
        </button>
      </div>
    </div>

    <!-- Contrôles webcam -->
    <div class="control-group">
      <button (click)="startWebcam()" [disabled]="isWebcamStarted">
        Démarrer Webcam
      </button>
      <button (click)="stopWebcam()" [disabled]="!isWebcamStarted">
        Arrêter Webcam
      </button>
    </div>

    <!-- Contrôles session -->
    <div class="control-group">
      <button (click)="startSession()" [disabled]="!isWebcamStarted || isSessionActive">
        Commencer Session
      </button>
      <button (click)="stopSession()" [disabled]="!isSessionActive">
        Arrêter Session
      </button>
      <div class="audio-status" *ngIf="isSpeaking">
        🔊 Lecture audio en cours...
      </div>
    </div>
  </div>

  <!-- Zone principale -->
  <div class="main-content">
    <!-- Vidéo -->
    <div class="video-container">
      <video #videoElement autoplay muted playsinline></video>
      <div class="video-overlay" *ngIf="isSessionActive">
        <div class="exercise-info">
          <h3>{{currentExercise || 'Détection en cours...'}}</h3>
          <div class="confidence-bar">
            <div class="confidence-fill"
                 [style.width.%]="confidence * 100"
                 [style.background-color]="getConfidenceColor()">
            </div>
            <span class="confidence-text">{{(confidence * 100).toFixed(1)}}%</span>
          </div>
        </div>
      </div>
    </div>


    <!-- Panneau de corrections -->
    <div class="corrections-panel" *ngIf="isSessionActive">
      <h3>Corrections</h3>
      <div class="corrections-list" *ngIf="corrections.length > 0; else noCorrections">
        <div *ngFor="let correction of corrections"
             class="correction-item"
             [ngClass]="getCorrectionSeverityClass(correction)">
          <strong>{{correction.type}}:</strong>
          <p>{{correction.message}}</p>
          <!-- Indicateur de lecture audio -->


        </div>
      </div>
      <ng-template #noCorrections>
        <p class="no-corrections">Excellente forme ! Continuez ainsi.</p>
      </ng-template>
    </div>
  </div>

</div>
<section class="skills" id="posecoach">
  <div class="titleskill reveal">
    <h2 class="titleskill colorw">
      <span>PoseCoach Beta – A Breakthrough in AR-Powered Learning</span>
      <span>68% of Beta Users Want Premium Features · Full Web Launch on July 15</span>
    </h2>
  </div>
  <div class="content">
    <!-- Left column: emotional pitch with social proof -->
    <div class="column col-left reveal">
      <h2 class="content-title">Be Part of the Future, Today</h2>
      <p>
        The software version changed the game for our early testers. Now, with the upcoming web release, it’s your turn to experience the impact. <strong>68% of beta users asked for premium access</strong>—without even knowing the price. Not because of hype, but because of results.
      </p>
      <p>
        This isn’t just another app. PoseCoach is where cutting-edge augmented reality meets deep educational purpose. With every gesture corrected and every concept visualized, you're not just learning—you’re evolving.
        <strong>Web access opens July 15. Only early registrants will receive the exclusive launch offer.</strong>
      </p>
      <button routerLink="/register" class="btn register urgency">Secure My Premium Access Now</button>

      <div class="social-proof">
        <p><em>"When 68% ask to upgrade before seeing the price, it means they’ve already seen the value."</em></p>
      </div>
    </div>

    <!-- Right column: enhanced feature highlights -->
    <div class="column col-right reveal">
      <div class="skills-grid">
        <div class="skill-card">
          <div class="icon-container">
            <img src="2.png" alt="AR Education Platform" />
          </div>
          <div class="skill-info">
            <h3>Complete AR Learning Ecosystem</h3>
            <p>
              Practice sales, explore physics, visualize chemistry, master robotics — all in lifelike 3D augmented reality, now accessible from any browser.
            </p>
          </div>
        </div>

        <div class="skill-card">
          <div class="icon-container">
            <img src="5.jpg" alt="Proven User Demand" />
          </div>
          <div class="skill-info">
            <h3>68% Eager for Premium</h3>
            <p>
              From day one, our beta testers knew this wasn’t ordinary. Their response? Immediate demand for more—more features, more access, more transformation.
            </p>
          </div>
        </div>

        <div class="skill-card">
          <div class="icon-container">
            <img src="12.jpg" alt="STEM Education" />
          </div>
          <div class="skill-info">
            <h3>STEM Mastery Made Visual</h3>
            <p>
              Concepts that once felt distant are now at your fingertips. PoseCoach makes invisible mechanisms tangible, leading to 31% better learning results.
            </p>
          </div>
        </div>

        <div class="skill-card">
          <div class="icon-container">
            <img src="4.png" alt="Limited Access" />
          </div>
          <div class="skill-info">
            <h3>Priority Launch Access</h3>
            <p>
              This web version is your entry point into elite learning. Only early users will benefit from our exclusive pricing and top-tier support.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Enhanced urgency and exclusivity call to action -->
  <div class="callout reveal">
    <div class="urgency-stats">
      <h3>Early Results, Real Impact:</h3>
      <div class="stats-grid">
        <div class="stat">
          <span class="number">68%</span>
          <span class="label">Asked for Premium</span>
        </div>
        <div class="stat">
          <span class="number">31%</span>
          <span class="label">Improved Learning</span>
        </div>
        <div class="stat">
          <span class="countdown">15 DAYS</span>
          <span class="label">Until Web Launch</span>
        </div>
      </div>
    </div>
    <p>
      <strong>Time is limited.</strong> The software version delivered results. Now the web version is opening up — and only early users will unlock the premium experience at launch. The next chapter of learning starts July 15.
      <em>Make sure you’re on the inside when the doors open.</em>
    </p>
    <button routerLink="/register" class="btn register primary">Claim My Exclusive Access</button>
  </div>
</section>
